import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
var _excluded = ["alignContent", "alignItems", "alignSelf", "bgColor", "borderBottomColor", "borderBottomStyle", "borderBottomWidth", "borderColor", "borderLeftColor", "borderLeftStyle", "borderLeftWidth", "borderRadius", "borderRightColor", "borderRightStyle", "borderRightWidth", "borderStyle", "borderTopColor", "borderTopStyle", "borderTopWidth", "borderWidth", "bottom", "children", "className", "clone", "color", "display", "flex", "flexBasis", "flexDirection", "flexGrow", "flexShrink", "flexWrap", "float", "fontStyle", "fontWeight", "height", "justifyContent", "left", "m", "maxHeight", "maxWidth", "mb", "ml", "mr", "mt", "mx", "my", "order", "p", "pb", "pl", "position", "pr", "pt", "px", "py", "right", "style", "textAlign", "textTransform", "top", "width", "zIndex"];

/* eslint-disable import/order */
import React, { forwardRef } from 'react';
import Base from '../Base';
import { removeEmptyKeys } from '../../utils';
import { getSystem, aliases } from '../../system';
import createCloneChildren from './createCloneChildren';
var Box = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var alignContent = _ref.alignContent,
      alignItems = _ref.alignItems,
      alignSelf = _ref.alignSelf,
      bgColor = _ref.bgColor,
      borderBottomColor = _ref.borderBottomColor,
      borderBottomStyle = _ref.borderBottomStyle,
      borderBottomWidth = _ref.borderBottomWidth,
      borderColor = _ref.borderColor,
      borderLeftColor = _ref.borderLeftColor,
      borderLeftStyle = _ref.borderLeftStyle,
      borderLeftWidth = _ref.borderLeftWidth,
      borderRadius = _ref.borderRadius,
      borderRightColor = _ref.borderRightColor,
      borderRightStyle = _ref.borderRightStyle,
      borderRightWidth = _ref.borderRightWidth,
      borderStyle = _ref.borderStyle,
      borderTopColor = _ref.borderTopColor,
      borderTopStyle = _ref.borderTopStyle,
      borderTopWidth = _ref.borderTopWidth,
      borderWidth = _ref.borderWidth,
      bottom = _ref.bottom,
      children = _ref.children,
      className = _ref.className,
      clone = _ref.clone,
      color = _ref.color,
      display = _ref.display,
      flex = _ref.flex,
      flexBasis = _ref.flexBasis,
      flexDirection = _ref.flexDirection,
      flexGrow = _ref.flexGrow,
      flexShrink = _ref.flexShrink,
      flexWrap = _ref.flexWrap,
      float = _ref.float,
      fontStyle = _ref.fontStyle,
      fontWeight = _ref.fontWeight,
      height = _ref.height,
      justifyContent = _ref.justifyContent,
      left = _ref.left,
      m = _ref.m,
      maxHeight = _ref.maxHeight,
      maxWidth = _ref.maxWidth,
      mb = _ref.mb,
      ml = _ref.ml,
      mr = _ref.mr,
      mt = _ref.mt,
      mx = _ref.mx,
      my = _ref.my,
      order = _ref.order,
      p = _ref.p,
      pb = _ref.pb,
      pl = _ref.pl,
      position = _ref.position,
      pr = _ref.pr,
      pt = _ref.pt,
      px = _ref.px,
      py = _ref.py,
      right = _ref.right,
      style = _ref.style,
      textAlign = _ref.textAlign,
      textTransform = _ref.textTransform,
      top = _ref.top,
      width = _ref.width,
      zIndex = _ref.zIndex,
      rest = _objectWithoutPropertiesLoose(_ref, _excluded);

  var allPropsObj = {
    alignContent: alignContent,
    alignItems: alignItems,
    alignSelf: alignSelf,
    bgColor: bgColor,
    borderBottomColor: borderBottomColor,
    borderBottomStyle: borderBottomStyle,
    borderBottomWidth: borderBottomWidth,
    borderColor: borderColor,
    borderLeftColor: borderLeftColor,
    borderLeftStyle: borderLeftStyle,
    borderLeftWidth: borderLeftWidth,
    borderRadius: borderRadius,
    borderRightColor: borderRightColor,
    borderRightStyle: borderRightStyle,
    borderRightWidth: borderRightWidth,
    borderStyle: borderStyle,
    borderTopColor: borderTopColor,
    borderTopStyle: borderTopStyle,
    borderTopWidth: borderTopWidth,
    borderWidth: borderWidth,
    bottom: bottom,
    color: color,
    display: display,
    flex: flex,
    flexBasis: flexBasis,
    flexDirection: flexDirection,
    flexGrow: flexGrow,
    flexShrink: flexShrink,
    flexWrap: flexWrap,
    float: float,
    fontStyle: fontStyle,
    fontWeight: fontWeight,
    height: height,
    justifyContent: justifyContent,
    left: left,
    m: m,
    maxHeight: maxHeight,
    maxWidth: maxWidth,
    mb: mb,
    ml: ml,
    mr: mr,
    mt: mt,
    mx: mx,
    my: my,
    order: order,
    p: p,
    pb: pb,
    pl: pl,
    position: position,
    pr: pr,
    pt: pt,
    px: px,
    py: py,
    right: right,
    textAlign: textAlign,
    textTransform: textTransform,
    top: top,
    width: width,
    zIndex: zIndex
  }; // Remove unused props from the allPropsObject.

  var usedProps = removeEmptyKeys(allPropsObj); // Use React.cloneElement and pass only allowedProps to the child component.

  if (clone) {
    // Has no ref passed trough
    return createCloneChildren({
      children: children,
      className: className,
      usedProps: usedProps,
      allPropsObj: allPropsObj,
      rest: rest,
      style: style
    });
  } // Generate Atom classnames and styles from the passed props.


  var _getSystem = getSystem(_extends({}, usedProps, {
    className: className,
    style: style
  })),
      classnames = _getSystem[0],
      styles = _getSystem[1];

  return /*#__PURE__*/React.createElement(Base, _extends({
    className: classnames,
    ref: ref,
    style: styles
  }, rest), children);
});
Box.displayName = 'Box';
Box.identifier = Box.displayName;
Box.aliases = aliases;
Box.defaultProps = {};
export default Box;